import React, {useCallback, useEffect, useMemo, useState} from 'react';
import * as PropTypes from 'prop-types';
import LoadingPopover from '../../LoadingPopover';
import NoBoardsPopover from './NoBoardsPopover';
import BoardsListPopover from './BoardsListPopover';
import * as boardsApi from 'utils/requests/boards';
import {apiUrl} from 'urls';
import {isUsersParticipateOrInvited} from './BoardsListPopover/utils';
import { invitationSource } from 'logic/requestParams';

const BoardsPopoverContainer = ({atiIds, children, visible, onPopoverVisibleChange}) => {
    const [boards, setBoards] = useState(null);
    const [loading, setLoading] = useState(false);
    const [saved, setSaved] = useState(false);

    const handleBoardSelectToggle = (event, boardId) => {
	    setBoards(prevBoards => {
		    const index = prevBoards.findIndex(b => b.id === boardId);
		    if (index !== -1) {
			    const newBoards = [...prevBoards];
			    newBoards[index] = {
				    ...newBoards[index],
				    checked: !newBoards[index].checked
			    };
			    return newBoards;
		    }
		    return prevBoards;
	    });
    };

    const getBoards = useCallback((withLoading) => {
        withLoading && setLoading(true);
        boardsApi.getBoardsForFirms(atiIds)
            .then((boards) => {
                setBoards(boards.map(b => ({
	                ...b,
	                checked: isUsersParticipateOrInvited(b, atiIds)
                })));
            }
            )
            .finally(()=>{
                withLoading && setLoading(false);
            });
    }, [atiIds, setBoards, setLoading]);

    const invite = useCallback((boardsIds) => {
        boardsApi.inviteFirmsToBoards({
            ati_ids: atiIds,
	        boards_ids: boardsIds,
            invitation_source: invitationSource.activeTrackersSearch
        }, apiUrl)
            .then(() => {
                getBoards(false);
                setSaved(true);
                setTimeout(() => setSaved(false), 2000);
            });
    }, [atiIds, getBoards]);


    const onVisibilityChange = useCallback((visible, event)=> {
        event?.preventDefault();
        onPopoverVisibleChange(visible);
    }, [onPopoverVisibleChange]);

    useEffect(() => {
	    if(visible && !boards){
		    getBoards(true);
	    }
    }, [boards, getBoards, visible]);

    const isEmptyBoards = useMemo(() =>
    {
        return !boards?.length;
    },[boards]);

    return (
        <div>
            {loading && (
                <LoadingPopover
                    visible = {visible}
                    onVisibilityChange={onVisibilityChange}
                >
                    {children}
                </LoadingPopover>
            )}
            {!loading && isEmptyBoards && (
                <NoBoardsPopover
                    visible = {visible}
                    onVisibilityChange={onVisibilityChange}
                >
                    {children}
                </NoBoardsPopover>
            )}

            {!loading && !isEmptyBoards && (
                <BoardsListPopover
	                atiIds={atiIds}
	                boards={boards}
	                saved={saved}
                    visible = {visible}
                    onBoardSelectToggle={handleBoardSelectToggle}
                    onInvite={invite}
                    onVisibilityChange={onVisibilityChange}
                >
                    {children}
                </BoardsListPopover>
            )}

        </div>
    );
};

BoardsPopoverContainer.defaultProps = {
    visible: false
};

export default BoardsPopoverContainer;

BoardsPopoverContainer.propTypes = {
    atiIds: PropTypes.arrayOf(PropTypes.string),
    children: PropTypes.node,
    visible: PropTypes.bool,
    onPopoverVisibleChange: PropTypes.func
};
